var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.eventosWeb)?_c('div',{staticClass:"container-fluid"},[_c('Home')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }